import { ColumnType, OptionalColumnEnum } from "../../enums/DRCXEnums";

export function makeOptionalColumnEquatableKey(
    optionalColumn: OptionalColumnEnum,
    key: string,
    id: number | undefined | null
): string {
    return id !== undefined && id !== null ? 
        `${ColumnType.Optional}:${typeof optionalColumn === "number" ? optionalColumn : ""}:${id}` :
        `${ColumnType.Optional}:${typeof optionalColumn === "number" ? optionalColumn : ""}:${typeof key === "string" ? key : ""}`;
}
